"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.incrementalCounterPropTypes = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * @param {Integer} props.end Sets an end value for counter to stop increasing
 * @param {Integer} props.start Sets a start value for counter to begin increasing from
 * @param {Float} props.speed Sets a multiplier for seconds between increments
 *
 * Renders an incremental counter that automatically keeps increasing a given
 * integer value by 1 until it reaches the end value or, if no end value given,
 * keeps counting forever.
 *
 */
var IncrementalCounter = function IncrementalCounter(_ref) {
  var end = _ref.end,
      start = _ref.start,
      speed = _ref.speed;

  var _useState = (0, _react.useState)(start || 0),
      _useState2 = _slicedToArray(_useState, 2),
      currentVal = _useState2[0],
      setCurrentVal = _useState2[1];

  var timer = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (end && end > currentVal) {
      timer.current = setTimeout(function () {
        setCurrentVal(function (val) {
          return val + 1;
        });
      }, 1000 * speed);
    } else {
      timer.current = setTimeout(function () {
        setCurrentVal(function (val) {
          return val + 1;
        });
      }, 1000 * speed);
    }

    return function () {
      clearTimeout(timer.current);
    };
  }, [currentVal]);
  var places = [];
  var currentValString = currentVal.toString();

  for (var i = 0; i < currentValString.length; i += 1) {
    var currentPlace = currentValString[currentValString.length - (i + 1)];

    if (i % 3 === 0 && i > 0) {
      places.unshift( /*#__PURE__*/_react["default"].createElement("span", {
        className: "counter-comma"
      }, ","));
    }

    places.unshift( /*#__PURE__*/_react["default"].createElement("span", {
      className: "counter-place",
      key: "".concat(Math.pow(10, i + 1), "-place")
    }, currentPlace));
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "counter"
  }, places);
};

var incrementalCounterPropTypes = {
  end: _propTypes["default"].number,
  start: _propTypes["default"].number,
  speed: _propTypes["default"].number
};
exports.incrementalCounterPropTypes = incrementalCounterPropTypes;
IncrementalCounter.propTypes = incrementalCounterPropTypes;
IncrementalCounter.defaultProps = {
  end: null,
  start: 1,
  speed: 1.0
};
var _default = IncrementalCounter;
exports["default"] = _default;